import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="paper-grain relative bg-shell py-16 sm:py-24" data-id="element-20" data-mp="av370wfflb2q">
      <Container className="relative" data-id="element-21" data-mp="fu69c9411370">
        <SectionHeading id="bonuses-heading" title={<>
              And You’ll Also Get These <span className="pop-sm-orange" data-id="element-23" data-mp="1t3o1ykuvwx5">Bonuses</span>
            </>} data-id="element-22" data-mp="fsv9gkdpcfl6" />

        <ul className="mx-auto mt-12 grid max-w-[980px] grid-cols-2 gap-2.5 sm:mt-16 sm:gap-5" data-id="element-24" data-mp="5xjr7s334q8o">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex flex-col overflow-hidden rounded-xl2 border border-hairline bg-white shadow-paper" data-id="element-25" data-mp="3t0ohc3a1fbn7" data-mpi={index}>
              <div className="relative" data-id="element-26" data-mp="1m85lnlxyzqk9">
                <img src={bonus.image} alt={bonus.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-27" data-mp="1r9ux32p3u68v" />
                <span className="absolute left-2.5 top-2.5 rounded-full bg-flame px-2.5 py-1 font-display text-[9px] font-extrabold uppercase tracking-[0.14em] text-white shadow-paper sm:left-4 sm:top-4 sm:px-3 sm:py-1.5 sm:text-[10px] sm:tracking-[0.16em]" data-id="element-28" data-mp="3dg4xas0exui3">
                  Free Bonus
                </span>
              </div>

              <div className="flex flex-1 flex-col p-3.5 sm:p-6" data-id="element-29" data-mp="2zg3w1bg8kl23">
                <span className="font-display text-[10px] font-bold uppercase tracking-[0.18em] text-muted sm:text-[11px] sm:tracking-[0.2em]" data-id="element-30" data-mp="2uh96zrroe09j">
                  Bonus #{index + 1}
                </span>
                <h3 className="pop-card mt-2 font-display text-[15px] font-extrabold leading-tight tracking-[-0.015em] text-ink sm:mt-2.5 sm:text-[19px]" data-id="element-31" data-mp="33gw4w3l74nxu">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[13px] font-semibold leading-[1.4] text-muted sm:mt-2.5 sm:text-[15px]" data-id="element-32" data-mp="ipwvvcgrge3s">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>
      </Container>
    </section>;
}